export type QueryParams = {
  search?: string;
  page?: string | number;
  limit?: string | number | 'unlimited';
  include?: string;
  includeRef?: string;
  orderBy?: string;
  subQuery?: boolean;
  filter?: string;
  filters?: string;    // Thêm filters
  sort?: string;
  searchKey?: string;
  searchValue?: string;
  checkedList?: string;
  transportOrderType?: string; 
} & { [key: string]: string | number | boolean | undefined };

export const getQueryParams = (data: { [key: string]: string | number | undefined | boolean }) => {
  const query = Object.keys(data)
    .filter((k) => data[k] !== undefined && data[k] !== "") // loại undefined
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(String(data[k])))
    .join('&');

  return query;
};
